import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/merchant-inbound-reject-return/constants'



const propTypes = {
  status: PropTypes.string
}

const defaultProps = {
  status: 'pending'
}

/**
 * @param {string} status
 */
const MerchantInboundRejectReturnStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.PENDING]   : 'warning',
    [STATUS.SCHEDULED] : 'success'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

MerchantInboundRejectReturnStatusBadge.propTypes    = propTypes
MerchantInboundRejectReturnStatusBadge.defaultProps = defaultProps

export default MerchantInboundRejectReturnStatusBadge
